export const BASENAME = '/support';

export enum LogLevel {
    TRACE = 1000,
    DEBUG = 2000,
    INFO = 3000,
    WARN = 4000,
    ERROR = 5000,
    FATAL = 6000
}

// When running locally, get settings from the .env file
// In production, these settings are injected into the index.html file by neon-app-server
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
    window._env = process.env;
}

if (window._vite_env) {
    window._env = window._vite_env;
}

const get = (name: string): string => {
    const value = window._env[name];
    if (!value) throw new Error('Environment variable ' + name + ' does not exist');
    return value;
};

const basePath = BASENAME;
const appHost = get('REACT_APP_HOST');
const baseUrl = appHost + basePath;

export const config = {
    auth0: {
        clientId: get('REACT_APP_AUTH_CLIENT_ID'),
        domain: get('REACT_APP_AUTH_DOMAIN'),
        audience: get('REACT_APP_AUTH_AUDIENCE'),
        redirectUri: baseUrl + '/callback',
        returnToUri: baseUrl + '/loggedout',
        namespace: 'https://' + get('REACT_APP_AUTH_DOMAIN') + '/'
    },
    logging: {
        level: LogLevel.INFO,
        url: `${BASENAME}/clientlog`,
        batchTimeout: 2000,
        batchSize: 10,
        maxBatchSize: 100
    },
    basePath,
    baseUrl,
    profilePageUrl: get('REACT_APP_LOGIN_PAGE') + '/manage-account/profile',
    landingPageUrl: get('REACT_APP_LANDING_PAGE_URL'),
    loginPageUrl: get('REACT_APP_LOGIN_PAGE'),
    loginMfaPageUrl: get('REACT_APP_LOGIN_PAGE') + '/loginMfa',
    aiPageUrl: get('REACT_APP_AI_PAGE'),
    enableMFA: get('REACT_APP_ENABLE_MFA') || 'false',
    enableCashMovements: get('REACT_APP_ENABLE_CASH_MOVEMENTS') || 'false',
    version: get('REACT_APP_VERSION'),
    serverUrl: get('REACT_APP_SERVER_URL'),
    dotnetServerUrl: get('REACT_APP_DOTNET_SERVER_URL'),
    env: get('REACT_APP_ENV') || 'dev',
    appName: 'Neon Support',
    scope: 'openid profile email portfolio',
    portfolioTradesPage: appHost + '/portfolio/positions',
    onboardingPortalUrl: appHost + '/onboarding-portal',
    agGrid: {
        license:
            'CompanyName=SPECTRON SERVICES LIMITED,LicensedGroup=Spectron,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=12,LicensedProductionInstancesCount=1,AssetReference=AG-023349,ExpiryDate=27_January_2023_[v2]_MTY3NDc3NzYwMDAwMA==ee49136ff35bcf08bb2982b06182db97'
    },
    bulkRequestLimit: Number(get('REACT_APP_BULK_REQUEST_LIMIT')) || 1000,
    amountLimit: Number(get('REACT_APP_PAYMENT_AMOUNT_LIMIT_USD')) || 1_000_000,
    contactSupportEmail: 'neon@marex.com',
    adobeSignUrl: get('REACT_APP_ADOBE_SIGN_URL'),
    neonTpsUrl: get('REACT_APP_NEON_TPS_URL') || '',
    enableProductLimits: get('REACT_APP_ENABLE_PRODUCT_LIMITS') || 'false'
};
